module.exports = __webpack_public_path__ + "static/takayasu-a3e9e11c3a26dd2aa85d8f879b880710.jpg";